import Checkbox from '@atoms/Checkbox/Checkbox';
import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import IFormComponent from '@models/IFormComponent';
import { IProductDatasheet } from '@models/IProductDatasheets';
import { ChangeEvent } from 'react';

interface IDownloadItemRow extends IFormComponent {
  readonly dataTestId: string;
  readonly selectedDocuments: IProductDatasheet[];
  readonly setSelectedDocuments: (newSelectedIds: IProductDatasheet[]) => void;
  readonly removeDocument: (id: number) => void;
  readonly value: IProductDatasheet;
  readonly label: string;
  readonly fileName: string;
  readonly name: string;
  readonly downloadLabel: string;
  readonly addLabel: string;
  readonly fileUrl: string;
  readonly cultureCode: string;
  readonly category: string;
  readonly customerInfo: {
    readonly industryNameForPageLoadTracking: string;
    readonly subIndustryNameForPageLoadTracking: string;
    readonly targetAudienceForPageLoadTracking: string;
    readonly regionForPageLoadTracking: string;
  };
}

const DownloadItemRow = ({
  dataTestId,
  selectedDocuments,
  setSelectedDocuments,
  removeDocument,
  value,
  name,
  addLabel,
  fileName,
  fileUrl,
  cultureCode,
  downloadLabel,
  category,
  register,
  customerInfo,
}: IDownloadItemRow) => {
  const onCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target?.checked;
    const document = JSON.parse(e.target.value);

    if (isChecked) {
      setSelectedDocuments([...selectedDocuments, document]);
    } else {
      removeDocument(document.id);
    }
  };

  return (
    <div className="tw-grid tw-grid-cols-4 tw-py-xs xl:tw-grid-cols-9 xl:tw-gap-md">
      <Text
        variant="body-small"
        className="tw-col-span-3 tw-pr-4 xl:tw-col-span-6"
      >
        {name}
      </Text>
      <div className="tw-col-span-1 tw-col-start-4 tw-flex tw-items-center tw-justify-between xl:tw-col-span-3 xl:tw-col-start-7">
        <a
          href={fileUrl}
          className="tw-flex tw-items-center tw-gap-2"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            window.dataLayer.push({
              event: 'trackingEvent_file_download',
              event_name_variable: 'file_download',
              trackingEvent_file_download: {
                document_name: fileName,
                language_for_document: cultureCode,
                document_type: category,
              },
              customer_info: {
                user_industry: customerInfo.industryNameForPageLoadTracking,
                user_sub_industry:
                  customerInfo.subIndustryNameForPageLoadTracking,
                user_region: customerInfo.regionForPageLoadTracking,
                target_audience: customerInfo.targetAudienceForPageLoadTracking,
              },
            });
          }}
          data-testid={`${dataTestId}-Download-Item-Button`}
        >
          <Icon name="download" />
          <Text variant="body-small" className="tw-hidden xl:tw-block">
            {downloadLabel}
          </Text>
        </a>
        <Checkbox
          checked={selectedDocuments
            .map((document) => document.id)
            .includes(value.id)}
          dataTestId={`${dataTestId}-Add-Item-Button`}
          onChange={onCheckboxChange}
          name="documents"
          value={JSON.stringify(value)}
          label={addLabel}
          register={register}
          hideLabelOnMobile
        />
      </div>
    </div>
  );
};

export default DownloadItemRow;
